
import { request } from "../utils/request";

export const getBundle = async (plan_id) =>
  request(
    `${process.env.NODE_APP_PROTOCOL}://${process.env.NODE_APP_HOSTNAME}:${
      process.env.NODE_APP_PORT
      }${process.env.NODE_APP_PATHNAME}plans/checkout?meal_plan_id=${plan_id}`
  );